// AdminFeedback.jsx
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Card,
  Row,
  CardBody,
  Input,
} from "reactstrap";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFeedbackType,
  getFeedbackList,
  getParentsToStaffFeddbacks,
} from "store/actions";
import moment from "moment";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import ParentsToAdminFeedback from "./ParentsToAdminFeedback";
import ParentsToTeacherFeedback from "./ParentsToTeacherFeedback";

const AdminFeedBack = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { feedbackType } = useSelector(state => state.FeedBackReducer);

  const PARENT_ORIGIN = 'https://pmapp.prisms.in/';

  window.addEventListener('message', event => {
    // This function helps to set localstorage information from other parent url on web login from php

    const host = event.origin;
    const parts = host.split('.');
    const rootDomain = parts.slice(-2).join('.');

    //console.log(rootDomain);

    // 1️⃣ Security check
    if (rootDomain === PARENT_ORIGIN) return;

    const { action, items } = event.data;
    if (action === 'bulkSet' && typeof items === 'object') {
      // 2️⃣ Loop through and store each item
      Object.entries(items).forEach(([key, value]) => {
        // Ensure everything is a string
        localStorage.setItem(key, String(value));
      });

      // 3️⃣ Send back a simple acknowledgment
      event.source.postMessage(
        { status: 'ok', storedKeys: Object.keys(items) },
        event.origin
      );
    }
  });

  // to change feedback type
  const changeTab = (feedbackType) => {
    dispatch(changeFeedbackType(feedbackType))

  }


  useEffect(() => {
    // This function redirects to dashbord if clicked on back button
    const handlePopState = () => {
      navigate("/dashboard");
    };

    window.addEventListener("popstate", handlePopState);


    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <div className="page-content">
      <div className="d-flex mb-2 mx-0 border border-2 p-1 rounded-3 overflow-auto">

        <div
          className={`border border-2 p-2 rounded-5 ${feedbackType === 0 ? 'bg-primary text-white' : ''}  text-nowrap `}
          onClick={() => changeTab(0)}
          style={{ cursor: 'pointer' }}
        >
          Parents to Admin
        </div>

        <div
          className={`border border-2 p-2 rounded-5 text-nowrap ${feedbackType === 1 ? 'bg-primary text-white' : ''}`}
          onClick={() => changeTab(1)}
          style={{ cursor: 'pointer' }}
        >
          Parents to Teachers
        </div>

      </div>


      {
        feedbackType === 0 ?
          <ParentsToAdminFeedback />
          :
          <ParentsToTeacherFeedback />
      }
    </div>
  );
};

export default AdminFeedBack;
